export enum Gender {
    any = 'any',
    man = 'man',
    woman = 'woman'
}